<template>
  <div class="flex items-center space-x-4">
    <NSwitch />

    <NSwitch outset />
  </div>
</template>
